import React from 'react';
import { motion } from 'framer-motion';
export function UrgencySection() {
  return <section className="w-full py-24 px-6 md:px-12 lg:px-24 bg-cream" data-id="element-210">
      <div className="max-w-3xl mx-auto text-center" data-id="element-211">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="space-y-8 text-lg md:text-xl text-charcoal-light leading-relaxed" data-id="element-212">
          <p className="text-2xl md:text-3xl font-serif text-charcoal" data-id="element-213">
            Every night that passes without this system is another Tuesday at
            the kitchen sink.
          </p>
          <p data-id="element-214">
            Another meltdown that catches you off guard. Another morning that
            starts with both of you already depleted. Another day of loving your
            child with everything you have but not having the right tool in your
            hand when it matters most.
          </p>
          <p className="text-2xl font-serif text-amber font-semibold pt-4" data-id="element-215">
            That changes tonight.
          </p>
          <p data-id="element-216">
            The launch price on this entire bundle will not last. Once this
            introductory window closes, the price increases to reflect the full
            value of what's inside.
          </p>
          <p className="text-2xl font-serif text-charcoal pt-4" data-id="element-217">
            You are one decision away from a different kind of Tuesday.
          </p>
        </motion.div>
      </div>
    </section>;
}